import styled from "styled-components";
import {Modal, Form, Select, InputNumber, Input, Upload, Button} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 10px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #ffa726 0%, #ffa726 100%);
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 10px 10px 0 0;

        .ant-modal-title {
            color: #000;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #000;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 24px;
        background: #fff;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 16px 24px;
        background: #fff;
        border-radius: 0 0 10px 10px;

        .ant-btn {
            height: 40px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
        }

        .ant-btn-primary {
            background: #ffa726 !important;
            border-color: #ffa726 !important;
            color: #fff !important;

            &:hover:not(:disabled) {
                background: #ffa726 !important;
                border-color: #ffa726 !important;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(255, 167, 38, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        .ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover {
                border-color: #ffa726;
                color: #ffa726;
            }
        }
    }
`;

export const StyledForm = styled(Form)`
    .ant-form-item-label > label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
    }

    .ant-form-item-explain-error {
        color: #ff4d4f;
        font-size: 12px;
        margin-top: 4px;
    }
`;

export const StyledSelect = styled(Select)`
    .ant-select-selector {
        height: 44px !important;
        border-radius: 6px !important;
        font-size: 16px !important;
        transition: all 0.3s ease !important;
        border: 1px solid #d9d9d9 !important;
    }

    .ant-select-selection-item {
        line-height: 42px !important;
    }

    &:hover .ant-select-selector {
        border-color: #ffa726 !important;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: #ffa726 !important;
        box-shadow: 0 0 0 2px rgba(255, 167, 38, 0.1) !important;
    }
`;

export const StyledInputNumber = styled(InputNumber)`
    .ant-input-number-input {
        height: 44px;
        border-radius: 6px;
        font-size: 16px;
        transition: all 0.3s ease;
    }

    .ant-input-number-handler-wrap {
        border-radius: 0 6px 6px 0;
    }

    &:hover .ant-input-number-input {
        border-color: #ffa726;
    }

    &.ant-input-number-focused .ant-input-number-input {
        border-color: #ffa726;
        box-shadow: 0 0 0 2px rgba(255, 167, 38, 0.1);
    }
`;

export const StyledInput = styled(Input)`
    height: 44px;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.3s ease;

    &:focus,
    &:hover {
        border-color: #ffa726;
        box-shadow: 0 0 0 2px rgba(255, 167, 38, 0.1);
    }
`;

export const StyledUpload = styled(Upload)`
    .ant-upload-list {
        margin-top: 12px;
    }

    .ant-upload-list-item {
        border-radius: 6px;
        border: 1px solid #e8e8e8;
        transition: all 0.3s ease;

        &:hover {
            border-color: #ffa726;
        }
    }

    .ant-upload-list-item-actions {
        .ant-btn {
            border-radius: 4px;
            transition: all 0.3s ease;

            &:hover {
                border-color: #ffa726;
                color: #ffa726;
            }
        }
    }
`;

export const StyledUploadButton = styled(Button)`
    height: 44px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
    border: 1px solid #d9d9d9;
    color: #666;

    &:hover {
        border-color: #ffa726;
        color: #ffa726;
    }

    .anticon {
        margin-right: 8px;
    }
`;
